import { render, staticRenderFns } from "./active4.vue?vue&type=template&id=783f691f&scoped=true"
import script from "./active4.vue?vue&type=script&lang=js"
export * from "./active4.vue?vue&type=script&lang=js"
import style0 from "./active4.vue?vue&type=style&index=0&id=783f691f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783f691f",
  null
  
)

export default component.exports